<template>
  <div>
    <div id="reportImage">
      <div class="top_box">
        <span style="color: #a4a4a4;"><span style="font-size: 12px;">媒体：</span>
          <van-tag type='primary' size="large" @click="clickTag(3)" color="#F4F5F7" text-color="#606060" :class="queryParams.isType === 3?'tag-click':'tag-before'">全部</van-tag>
          <van-tag type='primary' size="large" @click="clickTag(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.isType === 1?'tag-click':'tag-before'">腾讯</van-tag>
          <van-tag type='primary' size="large" @click="clickTag(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.isType === 2?'tag-click':'tag-before'">巨量</van-tag>
        </span>
        <span class="query_time" @click="showTimePicker">{{ queryParams.dateStr }}<van-icon class="query_icon_active" size="12" name="play" /></span>
        <!-- <van-icon style="margin-left: 10px; float: right;" size="20" name="filter-o" @click="handleFilter()" /> -->
      </div>
      <div class="top_box top_box_bottom">
        <span style="color: #a4a4a4;"><span style="font-size: 12px;">类型：</span>
          <van-tag type='primary' size="large" @click="clickType(null)" color="#F4F5F7" text-color="#606060" :class="queryParams.payType === null?'tag-click':'tag-before'">全部</van-tag>
          <van-tag type='primary' size="large" @click="clickType(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.payType === 1?'tag-click':'tag-before'">临时</van-tag>
          <van-tag type='primary' size="large" @click="clickType(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.payType === 2?'tag-click':'tag-before'">长期</van-tag>
        </span>
      </div>
      <div class="sectionList">
        <van-grid clickable :column-num="1" style="width: 100%">
          <van-grid-item>
            <van-tag class="describe" type="success">总垫款</van-tag>
            <div class="th_box">
              <div class="center_first" style="margin-top: 10px;">
                <div class="Statistics_name">截止当日</div>
                <div class="S_num S_num_xh">{{formaterMoney(amountPer.asOfNoReturnedMoney)}}</div>
                <div class="percent">
                  <van-icon :name="amountPer.asOfRingRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.asOfRingRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.asOfRingRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.asOfRingRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="center_first">
                <div class="Statistics_name">当日新增</div>
                <div class="S_num S_num_xh">{{formaterMoney(amountPer.augmentMoney)}}</div>
                <div class="percent">
                  <van-icon :name="amountPer.augmentRingRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.augmentRingRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.augmentRingRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.augmentRingRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
              <div class="center_first">
                <div class="Statistics_name">当日还款</div>
                <div class="S_num S_num_xh">{{formaterMoney(amountPer.repaymentMoney)}}</div>
                <div class="percent">
                  <van-icon :name="amountPer.repaymentRingRatio.toString().indexOf('-') == -1?'arrow-up':'arrow-down'" size="12" :color="amountPer.repaymentRingRatio.toString().indexOf('-') == -1?'#07c160':'#ee0a24'" />
                  <span class="percentage" :style="amountPer.repaymentRingRatio.toString().indexOf('-') == -1?'color: #07c160':'color: #ee0a24'">{{amountPer.repaymentRingRatio.toString().replace('-','')}}%</span>
                </div>
              </div>
            </div>
            <span class="describe2">单位(元)</span>
          </van-grid-item>
        </van-grid>
      </div>
      <div class="sectionList">
        <van-grid clickable :column-num="1" style="width: 100%">
          <van-grid-item>
            <van-tag class="describe" type="success">部门临时授信</van-tag>
            <div class="th_box">
              <div class="center_first" style="margin-top: 10px;">
                <div class="Statistics_name">总额度</div>
                <div class="S_num S_num_xh">{{formaterMoney(temporaryBalance.creditTempTotalMoney)}}</div>
              </div>
              <div class="center_first">
                <div class="Statistics_name">剩余额度</div>
                <div class="S_num S_num_xh">{{formaterMoney(temporaryBalance.creditTempResidueMoney)}}</div>
              </div>
              <div class="center_first">
                <div class="Statistics_name">已使用额度</div>
                <div class="S_num S_num_xh">{{formaterMoney(temporaryBalance.tempMoney)}}</div>
              </div>
            </div>
            <span class="describe2">单位(元)</span>
          </van-grid-item>
        </van-grid>
      </div>
      <div class="Statistics_title">
        <span>
          <van-tag type='primary' @click="clickDay(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.isDay === 1?'tag-click':'tag-before'">7天</van-tag>
          <van-tag type='primary' @click="clickDay(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.isDay === 2?'tag-click':'tag-before'">15天</van-tag>
        </span>
        <span class="title_dis">垫款趋势分析</span>
        <span class="placeholder"></span>
      </div>
      <div id="main01">
        <van-empty v-if="zkMoneyList.length === 0 || qdMoneyList.length === 0 || otherList.length === 0" description="暂无垫款趋势分析" />
      </div>
      <template v-if="queryParams.isType === 3">
        <div class="Statistics_title" style="justify-content: center;">
          <span class="title_dis">事业部垫款分析</span>
        </div>
        <div id="main02">
          <van-empty v-if="pieChartList.length === 0" description="暂无事业部垫款分析" />
        </div>
        <div class="Statistics_title">
          <span>
            <van-tag type='primary' @click="clickIsOverdue(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.isOverdue === 1?'tag-click':'tag-before'">逾期</van-tag>
            <van-tag type='primary' @click="clickIsOverdue(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.isOverdue === 2?'tag-click':'tag-before'">超额</van-tag>
          </span>
          <span class="title_dis2">重点客户情况</span>
          <span class="placeholder"></span>
        </div>
        <van-list v-model="loading" :finished="finished" @load="onLoad" v-if="emphasisList.length > 0">
          <!-- <total-component :totalValue="total" /> -->
          <van-cell v-for="(item, index) in emphasisList" :key="index" @click="toDetails(item)">
            <div style="display: flex; align-items: center; height:100%; width:100%">
              <span class="span_index" style="flex:0.1;">{{ index + 1 }}</span>
              <div style="flex: 1;">
                <div class="line_wrap"><span class="span_label1">客户名称：</span>{{ item.customerName }}【{{ item.userName }}】{{ item.creditCycleType?`(${item.creditCycleValue}个${formatHandel('creditCycleType',item.creditCycleType)})`:'' }}</div>
                <div>
                  <span class="span_label">未回款：</span>{{ formaterMoney(item.noReturnedMoney) }}
                </div>
                <div>
                  <span class="span_label">授信总额：</span>{{ formaterMoney(item.creditTotalMoney) }}
                </div>
                <div v-if="queryParams.isOverdue === 2">
                  <span class="span_label">剩余授信总额：</span><span style="color: #ee0a24;">{{ formaterMoney(item.creditResidueMoney) }}</span>
                </div>
              </div>
              <van-tag :type="item.isType == 1?'success':'warning'" style="flex:0.1;">{{ item.isType == 1?'腾讯':'巨量' }}</van-tag>
            </div>
          </van-cell>
        </van-list>
        <van-empty v-else description="暂无重点客户情况" style="height: 12rem;" />
      </template>
      <div style="padding-bottom: 1.5rem;">
        <div class="Statistics_title">
          <span>
            <van-tag type='primary' @click="clickCustSource(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 1?'tag-click':'tag-before'">直客</van-tag>
            <van-tag type='primary' @click="clickCustSource(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 2?'tag-click':'tag-before'">渠道</van-tag>
          </span>
          <span class="title_dis2" @click="handleShow('hn')">客户垫款TOP情况{{ queryParams.isType === 2?'':'' }}</span>
          <span @click="handleShow('hn')" style="color: #333;">{{ hnAdvanceVisible?'收起':'展开' }}<van-icon :class="hnAdvanceVisible?'query_icon_active':'query_icon'" size="12" name="play" /></span>
        </div>
        <div class="vant-table">
          <div v-if="hnAdvanceTopList.length > 0">
            <van-cell v-for="(item,index) in hnAdvanceTopList" :key="index" @click="toDetails(item)">
              <span class="span_index">{{ hnAdvanceVisible? index + 1 : index === 4? hnTopList.length : index + 1 }}</span>
              <div class="line_wrap">{{ item.customerName }}【{{ item.userName }}】{{ item.creditCycleType?`(${item.creditCycleValue}个${formatHandel('creditCycleType',item.creditCycleType)})`:'' }}</div>
              <div class="riyue_box">
                <div style="width: 49%;">
                  <span class="span_label">未回款:</span>{{ formaterMoney(item.noReturnedMoney) }}
                </div>
                <div style="width: 2%;"></div>
                <div style="width: 49%;">
                  <span class="span_label">授信总额:</span>{{ formaterMoney(item.creditTotalMoney) }}
                </div>
              </div>
            </van-cell>
          </div>
          <van-empty v-else :description="'暂无' + (queryParams.isType === 2? + '':'') + '客户垫款TOP情况'" />
        </div>
        <!-- <span class="span_label1">客户名称：</span> -->
        <!-- <template v-if="queryParams.isType === 2">
          <div class="Statistics_title">
            <span>
              <van-tag type='primary' @click="clickCustSource(1)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 1?'tag-click':'tag-before'">直客</van-tag>
              <van-tag type='primary' @click="clickCustSource(2)" color="#F4F5F7" text-color="#606060" :class="queryParams.custSource === 2?'tag-click':'tag-before'">渠道</van-tag>
            </span>
            <span class="title_dis2" @click="handleShow('gz')">客户垫款TOP情况(广州)</span>
            <span @click="handleShow('gz')" style="color: #333;">{{ gzAdvanceVisible?'收起':'展开' }}<van-icon :class="gzAdvanceVisible?'query_icon_active':'query_icon'" size="12" name="play" /></span>
          </div>
          <div class="vant-table">
            <div v-if="gzAdvanceTopList.length > 0" >
              <van-cell v-for="(item,index) in gzAdvanceTopList" :key="index" @click="toDetails(item)">
                <span class="span_index">{{ gzAdvanceVisible? index + 1 : index === 4? gzTopList.length : index + 1 }}</span>
                <div class="line_wrap">{{ item.customerName }}{{ item.creditCycleType?`(${item.creditCycleValue}个${formatHandel('creditCycleType',item.creditCycleType)})`:'' }}</div>
                <div class="riyue_box">
                  <div style="width: 49%;">
                    <span class="span_label">未回款:</span>{{ formaterMoney(item.noReturnedMoney) }}
                  </div>
                  <div style="width: 2%;"></div>
                  <div style="width: 49%;">
                    <span class="span_label">授信总额:</span>{{ formaterMoney(item.creditTotalMoney) }}
                  </div>
                </div>
              </van-cell>
            </div>
            <van-empty v-else description="暂无广州的客户垫款TOP情况" />
          </div>
        </template> -->
      </div>
    </div>
    <!-- <div class="radio_group">
      <van-button type="warning" block style="width: 60%;margin: 0 auto;border-radius: 10px;" @click="screenshot">生成报告</van-button>
    </div> -->

    <van-image-preview v-model="imageShow" :images="imageArr"></van-image-preview>
    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :max-date="datePicker.maxDate" :type="datePicker.type" @confirm="datePickerConfirm" />
  </div>
</template>

<script>
import {
  Grid,
  GridItem,
  Popover,
  Calendar,
  Toast,
  ImagePreview
} from 'vant'
import statistics from '@/api/tongji/statistics'
import { formaterMoney } from '@/utils/util'
import * as echarts from 'echarts'
import html2canvas from 'html2canvas'

export default {
  name: 'TongjiIndex',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Popover.name]: Popover,
    [Calendar.name]: Calendar,
    [Toast.name]: Toast,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  props: {},
  data() {
    return {
      showFilterPop: false,
      showPopover1: false,
      showPopover2: false,
      offset: [100, 0],
      isNone: false,
      // activeNames: ['1'],
      // icon_title: require('../../assets/images/tj/ghicon.png'),
      activeId: '1',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        deptId: null,
        startTime: null,
        endTime: null,
        isType: 3,
        payType: null,
        isDay: 1,
        custSource: 1,
        isOverdue: 1,
        dateStr: null
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2023, 0, 1),
        maxDate: new Date(),
        type: 'single',
        formKey: ''
      },
      amountPer: {
        asOfNoReturnedMoney: 0,
        augmentMoney: 0,
        repaymentMoney: 0,
        asOfRingRatio: 0,
        augmentRingRatio: 0,
        repaymentRingRatio: 0
      },
      // 部门临时授信
      temporaryBalance: {
        creditTempTotalMoney: 0,
        creditTempResidueMoney: 0,
        tempMoney: 0
      },
      dateList: [],
      qdMoneyList: [],
      zkMoneyList: [],
      otherList: [],

      pieChartList: [],

      loading: false,
      finished: false,
      emphasisList: [],
      total: 0,

      hnAdvanceVisible: false,
      gzAdvanceVisible: false,
      hnTopList: [],
      gzTopList: [],
      hnAdvanceTopList: [],
      gzAdvanceTopList: [],
      options: {
        creditCycleTypeOptions: [] // 授信周期类型
      },

      imageShow: false,
      imageArr: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getDicts('credit_cycle_type').then(res => {
      this.options.creditCycleTypeOptions = res.data
    })
    this.datePicker.minDate = new Date(this.getNextDate(-1).split('-')[0] - 1, 0, 1)
    this.queryParams.dateStr = this.getNextDate(0)
  },
  async mounted() {
    this.init()
    await this.getStatistics()
    await this.getBalance()
    await this.getTendency()
    await this.getPieChart()
    await this.getEmphasisAdvancesTop()
    await this.getAdvancesTop()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '垫款统计'
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      return y + '-' + m + '-' + d
    },
    showTimePicker(type) {
      this.datePicker.formKey = type
      this.datePicker.showDate = true
    },
    async datePickerConfirm(date) {
      this.queryParams.dateStr = this.formatDateTime(date)
      this.datePicker.showDate = false
      await this.getStatistics()
      await this.getBalance()
      await this.getTendency()
      await this.queryList()
      await this.getAdvancesTop()
      if (this.queryParams.isType !== 3) {

      } else {
        await this.getPieChart()
      }
    },
    // date 代表指定的日期，格式：2023-09-27
    // day 传-1表始前一天，传1表始后一天
    getNextDate(day) {
      var dd = new Date()
      dd.setDate(dd.getDate() + day)
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
      return y + '-' + m + '-' + d
    },
    // 获取统计数
    async getStatistics() {
      await statistics.getAdvancesStatistics(this.queryParams).then(async res => {
        if (res.code === 200) {
          this.amountPer = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 获取部门临时授信
    async getBalance() {
      await statistics.getTemporaryBalance(this.queryParams).then(async res => {
        if (res.code === 200) {
          this.temporaryBalance = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    async getTendency() {
      await statistics.getAdvancesTendency(this.queryParams).then(async res => {
        if (res.code === 200) {
          this.dateList = []
          this.qdMoneyList = []
          this.zkMoneyList = []
          this.otherList = []
          if (res.data.length > 0) {
            const arr = res.data
            arr.forEach(item => {
              this.dateList.push(item.date)
              this.qdMoneyList.push(item.execMoney)
              this.zkMoneyList.push(item.contMoney)
              this.otherList.push(item.otherMoney)
            })
            await this.drawChart()
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    async getPieChart() {
      this.pieChartList = []
      await statistics.getAdvancesPieChart(this.queryParams).then(async res => {
        if (res.code === 200) {
          // this.pieChartList.push({ name: '腾讯', value: res.data.TXnoReturnedMoney })
          // this.pieChartList.push({ name: '抖音AD', value: res.data.DYnoReturnedMoney })
          // this.pieChartList.push({ name: '抖音千川', value: res.data.JLnoReturnedMoney })
          res.data.forEach(item => {
            this.pieChartList.push({ name: item.name, value: item.noReturnedMoney })
          })
          await this.drawChartPie()
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    async getEmphasisAdvancesTop() {
      this.loading = true
      await statistics.getEmphasisAdvancesTop(this.queryParams).then(res => {
        if (res.code === 200) {
          this.emphasisList = this.emphasisList.concat(...res.rows)
          this.queryParams.pageNum += 1
          this.total = res.total
          this.finished = this.emphasisList.length >= res.total
          this.loading = false
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    onLoad() {
      this.getEmphasisAdvancesTop()
    },
    queryList() {
      this.emphasisList = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.getEmphasisAdvancesTop()
    },
    async getAdvancesTop() {
      this.hnAdvanceVisible = false
      this.gzAdvanceVisible = false
      await statistics.getAdvancesTopList({ ...this.queryParams, pageNum: 1, pageSize: 20, isHn: 1 }).then(res => {
        if (res.code === 200) {
          this.hnTopList = res.rows
          if (res.rows.length > 5) {
            this.hnAdvanceTopList = res.rows.slice(0, 4).concat(res.rows[res.rows.length - 1])
          } else {
            this.hnAdvanceTopList = res.rows
          }
        } else {
          Toast.fail(res.msg)
        }
      })
      // if (this.queryParams.isType === 2) {
      //   await statistics.getAdvancesTopList({ ...this.queryParams, pageNum: 1, pageSize: 20, isHn: 2 }).then(res => {
      //     if (res.code === 200) {
      //       this.gzTopList = res.rows
      //       if (res.rows.length > 5) {
      //         this.gzAdvanceTopList = res.rows.slice(0, 4).concat(res.rows[res.rows.length - 1])
      //       } else {
      //         this.gzAdvanceTopList = res.rows
      //       }
      //     } else {
      //       Toast.fail(res.msg)
      //     }
      //   })
      // }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    async clickTag(id) {
      this.queryParams.isType = id
      await this.getStatistics()
      await this.getBalance()
      await this.getTendency()
      await this.queryList()
      await this.getAdvancesTop()
      if (id !== 3) {

      } else {
        await this.getPieChart()
      }
    },
    async clickType(val) {
      this.queryParams.payType = val
      await this.getStatistics()
      await this.getBalance()
      await this.getTendency()
      await this.queryList()
      await this.getAdvancesTop()
      if (this.queryParams.isType !== 3) {

      } else {
        await this.getPieChart()
      }
    },
    async clickDay(id) {
      this.queryParams.isDay = id
      await this.getStatistics()
      await this.getBalance()
      await this.getTendency()
    },
    async clickCustSource(id) {
      this.queryParams.custSource = id
      await this.getStatistics()
      await this.getBalance()
      await this.getAdvancesTop()
    },
    async clickIsOverdue(id) {
      this.queryParams.isOverdue = id
      this.queryList()
    },
    drawChart() {
      var chartDom = document.getElementById('main01')
      var myChart = echarts.init(chartDom)
      var option
      const that = this
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            var htmlStr = '<div style="width: auto;height: auto;max-height: 240px;overflow-y: auto;"><p>' + params[0].axisValue + '</p>'
            var sum = 0
            for (var j = 0; j < params.length; j++) {
              sum += params[j].value
            }
            htmlStr += '<p style="color: #666;">全部：' + formaterMoney(sum) + '</p>'
            for (var i = 0; i < params.length; i++) {
              htmlStr += '<p style="color: #666;">' + params[i].marker + formaterMoney(params[i].value) + '<span style="margin-left: 5px;color: #07c160;">' + (sum == 0 ? 0 : (params[i].value / sum * 100).toFixed(2)) + '%</span></p>'
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        legend: {
          data: ['直客', '渠道', '其它']
        },
        xAxis: [
          {
            type: 'category',
            data: that.dateList,
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              inside: true
            },
            scale: true,
            min: 0, // 设置y轴最小值
            axisLabel: {
              margin: 2,
              formatter: function (value, index) {
                if (value >= 10000 && value < 10000000) {
                  value = value / 10000 + '万'
                } else if (value >= 10000000) {
                  value = value / 10000000 + '千万'
                }
                return value
              }
            }
          }
        ],
        grid: {
          left: 42
        },
        series: [
          {
            name: '直客',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.zkMoneyList
          },
          {
            name: '渠道',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.qdMoneyList
          },
          {
            name: '其它',
            type: 'bar',
            stack: 'stack',
            emphasis: {
              focus: 'series'
            },
            data: that.otherList
          }
        ]
      }
      option && myChart.setOption(option)
    },
    drawChartPie() {
      var chartDom = document.getElementById('main02')
      var myChart = echarts.init(chartDom)
      var option
      const that = this
      // pieChartList
      if (!this.pieChartList || this.pieChartList.length == 0) {
        chartDom.innerHTML = ('-暂无相关数据-')
        chartDom.style.cssText = 'text-align:center; color: #999; border: none;line-height: 300px;font-size: 18px;'
        chartDom.removeAttribute('_echarts_instance_')
        return
      }
      option = {
        // title: {
        //   text: 'Referer of a Website',
        //   subtext: 'Fake Data',
        //   left: 'center'
        // },
        tooltip: {
          trigger: 'item',
          // formatter: '{b}<br/>总金额：{c}元<br/>占比：{d}%' // 鼠标放上去 展示内容
          formatter: function(params) {
            return `${params.name}<br/>总金额：${formaterMoney(params.value)}元<br/>占比：${params.percent}%`
          }
        },
        legend: {
          orient: 'horizontal',
          // left: 'left'
          pageIconSize: 13,
          type: 'scroll'
        },
        series: [
          {
            // name: '金额',
            // top: 30,
            top: '',
            type: 'pie',
            radius: '50%',
            // label: {
            //   normal: {
            //     formatter: '{b} [{c}元  {d}%]' //
            //   }
            // },
            data: that.pieChartList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    handleShow(type) {
      this[type + 'AdvanceVisible'] = !this[type + 'AdvanceVisible']
      if (this[type + 'AdvanceVisible'] || this[type + 'TopList'].length < 5) {
        this[type + 'AdvanceTopList'] = this[type + 'TopList']
      } else {
        this[type + 'AdvanceTopList'] = this[type + 'TopList'].slice(0, 4).concat(this[type + 'TopList'][this[type + 'TopList'].length - 1])
      }
    },
    toDetails(item) {
      this.$router.push({
        path: '/cont/approve/detail',
        query: { id: item.contractId, active: 'diankuan' }
      })
    },
    screenshot() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '生成报告中...'
      })
      html2canvas(document.querySelector('#reportImage'), {
        allowTaint: false, // 允许污染
        taintTest: true, // 在渲染前测试图片(没整明白有啥用)
        useCORS: true, // 使用跨域(当allowTaint为true时这段代码没什么用)
        background: '#fff'
      }).then((image) => {
        const url = image.toDataURL('image/png', 1.0)
        Toast.clear()
        this.imageShow = true
        this.imageArr = []
        this.imageArr.push(url)
      })
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
.placeholder{
  width: 80px;
}
.query_time{
  margin-left: -60px;
  margin-top: 20px;
  font-size: 40px;
  font-weight: bold;
  color: #1E90FF;
}
.query_icon{
  margin-left: 10px;
}
.query_icon_active{
  margin-left: 10px;
  transform: rotate(90deg);
}
.top_box{
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 20px 0px 20px;
}
.top_box_bottom{
  padding: 0px 20px 32px 20px;
}
.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}

.sectionList {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  /deep/.van-grid-item__content{
    padding: 20px;
  }
  .describe{
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .describe2{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #b4b4b4;
    font-size: 24px;
  }
  .th_box{
    padding-top: 10px;
    // padding-bottom: 30px;
    width: 100%;
    .center {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-top: 20px;
      .Statistics_num {
        font-size: 30px;
        font-weight: bold;
        color: #0000FF;
        margin-left: 20px;
        margin-right: 20px;
      }
      .Statistics_name{
        margin-top: 20px;
        font-size: 26px;
        color: #87CEFA;
        font-weight: bold;
      }
      .percent{
        // display: flex;
        // justify-content: flex-end;
        width: 50%;
        text-align: right;
      }
      .percentage{
        font-size: 16px !important;
      }
    }
    .S_num {
      width: 100%;
      font-size: 32px;
      font-weight: bold;
      color: #0000FF;
      // text-align: center;
      padding: 10px 0 0 10px;
      // margin-left: 20px;
      // margin-right: 20px;
    }
    .S_num_xh{
      font-size: 36px;
    }
    .center_first{
      margin: 0 auto;
      width: 70%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .Statistics_num {
        font-size: 30px;
        font-weight: bold;
        color: #0000FF;
      }
      .Statistics_name{
        width: 44%;
        margin-top: 10px;
        font-size: 26px;
        color: #87CEFA;
        font-weight: bold;
      }
      .percent{
        // display: flex;
        // justify-content: flex-end;
        width: 32%;
        text-align: right;
      }
      .percentage{
        font-size: 16px !important;
      }
    }
  }
}
// .rrr{
//   height: 100px;
// }
.Statistics_title{
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  font-size: 30px;
  color:#87CEFA;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.radio_group{
  background-color: #fff;
  margin-top: 10px;
  padding: 40px 0 160px 0;
}
.none{
  background-color: #fff;
  margin-top: 10px;
  height: 660px;
}
.contTip{
  padding: 20px;
  width: 600px;
  font-size: 16px;
  color: #333;
}
#main01{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-bottom: 12px;
}
#main02{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-bottom: 12px;
}
#main03{
  width: 100%;
  height: 700px;
  background-color: #fff;
  margin-top: 10px;
  padding-bottom: 12px;
}

/deep/.van-tabs{
  background-color: #fff;
}
/deep/.van-tabs__line{
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1.06667rem;
  height: 0.08rem;
  background-color: #1989fa;
  border-radius: 0.08rem;
}
/deep/.van-tab--active{
  color: #87CEFA;
}
/deep/.van-tab__text{
  font-size: 24px;
  font-weight: bold;
}
.vant-table{
  background-color: #fff;
  line-height: 50px;
  font-size: 28px;
  color: #666;
  .span_index{
    display: inline-block;
    width: 50px;
  }
  .riyue_box{
    margin-left: 40px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
  }
  .span_label{
    color: #b4b4b4;
  }
  .line_wrap{
    width: 92%;
    display: inline-block;
    // padding-left: 130px;
    // text-indent: -130px;
  }
  .span_label1 {
    color: #b4b4b4;
    margin-left: -10px;
  }
  .progress{
    width: 94%;
    margin: 20px 0 20px 40px;
  }
}

/deep/.van-list{
  padding-top: 0;
  padding-bottom: 0;
  .span_label{
    color: #b4b4b4;
  }
  .line_wrap{
    margin-left: 10px;
    padding-left: 130px;
    text-indent: -130px;
  }
  .span_label1 {
    color: #b4b4b4;
    margin-left: -10px;
  }
}
</style>
